import { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import './fonts.css';
import Dashboard from './pages/Dashboard';
import CreateStudy from './pages/Study/CreateStudy';
import StudyDetail from './pages/Study/StudyDetails';
import ForgotPassword from './pages/Auth/ForgotPassword';
import PasswordReset from './pages/Auth/PasswordReset';
import Settings from './pages/Settings';
import Notifications from './pages/Notification';
import Support from './pages/Study/Support';
import InvestigatorStudyDetail from './pages/Study/InvestigatorStudyDetails';
import PatientSignatureConsent from './pages/Patient/PatientSignatureConsent';
import PatientReconsentSignature from './pages/Patient/ReconsentSignature';
import PatientQRCode from './pages/Patient/PatientQRcode';
import QRCodeError from './pages/Patient/QRCodeError';
import PatientDashboard from "./pages/Patient/PatientDashboard";
import QRScanFailed from './pages/Verification/QRScanFailed';
import ConsentOutdated from './pages/Verification/ConsenetOutdated';
import ConsentUpToDate from './pages/Verification/ConsentToUpDate';
import MilestoneError from './pages/Verification/MilestoneError';
import MilestoneLogged from './pages/Verification/MilestoneLogged'; 

import UserSignup from './pages/Auth/User/UserSignup';
import UserSignIn from './pages/Auth/User/UserSignIn';
import UserSignUpPassword from './pages/Auth/User/UserSignUpPassword';
import Invitation from './pages/Auth/User/Invitation';

import CROCreateCompanySignUp from './pages/Auth/CRO/CROCreateCompanySignUp';
import CROSignUpEmail from './pages/Auth/CRO/CROEmail';
import UserSignupRequestAccess from './pages/Auth/Patient/UserSignupRequestAccess';
import SignUpPatientInformation from './pages/Auth/Patient/SignUpPatient';
import CROSignupRequestAccess from './pages/Auth/CRO/CROSignupRequestAccess';
import PatientSettings from './pages/Patient/PatientSettings';
import NavigationService from "@services/navigation.service.js";
import { useSession } from "@hooks/useSession";

const AppNavigator = ({children})=>{
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(0);

  const refreshFunction = ()=>{
    setRefresh((prev)=>prev+1);
  }

  useEffect(() => {
    NavigationService.setNavigate(navigate);
    NavigationService.setRefreshFunction(refreshFunction);
  }, [navigate]);
  return <>{children}</>;
}

function App() {

  
  return (
        <Router>
          <AppNavigator>
          {/* Auth */} 
            <Routes>
              <Route path="/" element={<UserSignIn/>}/>
              <Route path="/invitation" element={<Invitation/>}/>
              {/* Auth manage password */} 
            <Route path="/forgot-password" element={<ForgotPassword/>}/>
            <Route path="/reset-password" element={<PasswordReset/>}/>
            {/* USER Auth */} 
            <Route path="/user-signup" element={<UserSignup/>} />
            <Route path="/user-signin" element={<UserSignIn/>}/>
            <Route path="/user-signup-password" element={<UserSignUpPassword/>}/>
            <Route path="/user-request-access" element={<UserSignupRequestAccess/>}/>
            {/* CRO Auth */} 
            <Route path="/cro-create-company-signup" element={<CROCreateCompanySignUp />} />
            <Route path="/cro-email" element={<CROSignUpEmail />} />
            <Route path="/cro-request-access" element={<CROSignupRequestAccess/>} />
            {/* Patient Auth */}
            <Route path="/patient-information" element={<SignUpPatientInformation/>}/>
            
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/create-study" element={<CreateStudy/>} />
            <Route path="/study/:id" element={<StudyDetail />} />
            <Route path="/investigator/study/:id" element={<InvestigatorStudyDetail />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/support" element={<Support />} />
            <Route path="/patient-consent-signature" element={<PatientSignatureConsent/> }/>
            <Route path="/patient-reconsent-signature" element={<PatientReconsentSignature/> }/>
            <Route path="/patient-qr-code" element={<PatientQRCode/> }/>
            <Route path="/patient-qr-code-error" element={<QRCodeError/> }/>
            <Route path="/patient-settings" element={<PatientSettings/> }/>
            <Route path="/patient-dashboard" element={<PatientDashboard/> }/>




          <Route path="/qr-scan-failed" element={<QRScanFailed />} />
          <Route path="/consent-outdated" element={<ConsentOutdated />} />
          <Route path="/consent-up-to-date" element={<ConsentUpToDate />} />
          <Route path="/milestone-error" element={<MilestoneError />} />
          <Route path="/milestone-logged" element={<MilestoneLogged />} />
          </Routes>
          </AppNavigator>
        </Router>
  );
}

export default App;

